import useCurriculum from "./useCurriculum";

export default function useHasCurriculumAccess() {
  const curriculum = useCurriculum();

  return !!curriculum;
}
